import { render, staticRenderFns } from "./VipServiceAgreement.vue?vue&type=template&id=165e8691&scoped=true&"
var script = {}
import style0 from "./VipServiceAgreement.vue?vue&type=style&index=0&id=165e8691&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e8691",
  null
  
)

export default component.exports